import { render } from "./InternalVariants.vue?vue&type=template&id=deb81062&scoped=true&ts=true"
import script from "./InternalVariants.vue?vue&type=script&lang=ts"
export * from "./InternalVariants.vue?vue&type=script&lang=ts"

import "./InternalVariants.vue?vue&type=style&index=0&id=deb81062&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb81062"]])

export default __exports__